"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var _reactHookForm = require("react-hook-form");

var _devtools = require("@hookform/devtools");

var _lodash = require("lodash");

var _Summary = _interopRequireDefault(require("./Summary"));

var _Label = _interopRequireDefault(require("./Label"));

var _Error = _interopRequireDefault(require("./Error"));

var _Field = _interopRequireDefault(require("./Field"));

var _Group = _interopRequireDefault(require("./Group"));

var _Hint = _interopRequireDefault(require("./Hint"));

var _Input = _interopRequireDefault(require("./Input"));

var _Select = _interopRequireDefault(require("./Select"));

var _MultiSelect = _interopRequireDefault(require("./MultiSelect"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mergeData(objects) {
  return _lodash.mergeWith.apply(void 0, (0, _tslib.__spreadArrays)([{}], objects, [function (contextValue, dataValue) {
    /**
     * We do this condition in the case of a text input. Inputs default a text field to an empty
     * string by default, so validation will fail if it is an empty string and the field is required
     * but nullable. Here, if the initial state of a field was null, and the text field is "empty",
     * we should return null.
     */
    if (contextValue === null && dataValue === '') {
      return null;
    }

    return undefined;
  }]));
}

function useYupValidationResolver(validationSchema) {
  var _this = this;

  return _react.default.useCallback(function (data, context) {
    return (0, _tslib.__awaiter)(_this, void 0, void 0, function () {
      var mergedData, values, errors_1;
      return (0, _tslib.__generator)(this, function (_a) {
        switch (_a.label) {
          case 0:
            mergedData = mergeData([context, data]);
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , validationSchema.validate(mergedData, {
              abortEarly: false
            })];

          case 2:
            values = _a.sent();
            return [2
            /*return*/
            , {
              values: values,
              errors: {}
            }];

          case 3:
            errors_1 = _a.sent();
            return [2
            /*return*/
            , {
              values: {},
              errors: (0, _lodash.reduce)(errors_1.inner, function (allErrors, currentError) {
                var _a;

                return (0, _tslib.__assign)((0, _tslib.__assign)({}, allErrors), (_a = {}, _a[currentError.path] = currentError.message, _a));
              }, {})
            }];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  }, [validationSchema]);
}

var Form = function Form(_a) {
  var children = _a.children,
      _b = _a.debug,
      debug = _b === void 0 ? false : _b,
      initialValues = _a.initialValues,
      onSubmit = _a.onSubmit,
      _c = _a.summary,
      summary = _c === void 0 ? false : _c,
      validationSchema = _a.validationSchema,
      props = (0, _tslib.__rest)(_a, ["children", "debug", "initialValues", "onSubmit", "summary", "validationSchema"]);

  var memoIzedValidationSchema = _react.default.useMemo(function () {
    return validationSchema;
  },
  /**
   * Leaving the dependency array empty for the time being. There shouldn't be any instance where
   * the schema passed would change at any lifecycle point of the form. If there comes a time
   * where that's necessary and causes bugs, we should add an option to add the schema to the
   * dependency array.
   */
  []);

  var validationResolver = useYupValidationResolver(memoIzedValidationSchema);

  var handleSubmit = function handleSubmit(data, submit) {
    var mergedData = mergeData([initialValues, data]);
    return submit(mergedData);
  };

  var methods = (0, _reactHookForm.useForm)((0, _tslib.__assign)({
    defaultValues: initialValues,
    resolver: validationSchema && validationResolver
  }, props));
  return _react.default.createElement(_reactHookForm.FormProvider, (0, _tslib.__assign)({}, methods), _react.default.createElement("form", {
    onSubmit: methods.handleSubmit(function (data) {
      return handleSubmit(data, onSubmit);
    })
  }, Object.keys(methods.errors).length > 0 && summary && _react.default.createElement(_Summary.default, {
    errors: methods.errors
  }), children), debug && _react.default.createElement(_devtools.DevTool, {
    control: methods.control
  }));
};

Form.displayName = 'Form';
Form.Error = _Error.default;
Form.Field = _Field.default;
Form.Group = _Group.default;
Form.Hint = _Hint.default;
Form.Input = _Input.default;
Form.Label = _Label.default;
Form.MultiSelect = _MultiSelect.default;
Form.Select = _Select.default;
var _default = Form;
exports.default = _default;